import _ from 'lodash';

import sy from '~/styles';
import {Text} from '~/components/controls';
import Format from '~/lib/format';

import PublishedWithChangesIcon from '~/images/md-icons/published_with_changes/materialicons/24px.svg';
import MoreTimeIcon from '~/images/md-icons/more_time/materialicons/24px.svg';
import TimerIcon from '~/images/md-icons/timer/materialsymbolsoutlined/24px.svg';

export const DurationText = ({
  duration,
  original_duration,
  original_work_time,
  calculated_work_time,
}) => {
  if (!_.isFinite(duration)) {
    return null;
  }

  let work_time;
  if (
    _.isNil(original_duration) &&
    _.isFinite(calculated_work_time) &&
    duration === calculated_work_time
  ) {
    work_time = original_work_time;
  } else {
    work_time = _.isFinite(calculated_work_time)
      ? calculated_work_time
      : original_work_time;
  }

  return (
    <>
      {_.isFinite(work_time) && duration !== work_time && (
        <Text
          style={[
            sy.smallCondensedRegular,
            sy['text-lightgray'],
            sy['line-through'],
          ]}>
          {Format.number(work_time, 2)}
          &nbsp;u
        </Text>
      )}
      <Text style={[sy.smallCondensedRegular, sy['text-lightgray']]}>
        {Format.number(duration, 2)}
        &nbsp;u
      </Text>
    </>
  );
};

export const DurationIcon = ({
  width = 18,
  height = 18,
  duration,
  original_duration,
  original_work_time,
  calculated_work_time,
}) => {
  if (!_.isFinite(duration)) {
    return null;
  }

  if (
    _.isNil(original_duration) &&
    _.isFinite(calculated_work_time) &&
    duration === calculated_work_time
  ) {
    return (
      <PublishedWithChangesIcon fill="#299976" width={width} height={height} />
    );
  }

  if (!_.isFinite(original_work_time)) {
    return <TimerIcon fill="#FF6C00" width={width} height={height} />;
  }

  const work_time = _.isFinite(calculated_work_time)
    ? calculated_work_time
    : original_work_time;

  if (duration > work_time) {
    return <MoreTimeIcon fill="#FF6C00" width={width} height={height} />;
  }
};
